"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _setEnvRef = _interopRequireDefault(require("@uie/set-env-ref"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _DropdownSelectMarketingTrigger = _interopRequireDefault(require("./DropdownSelectMarketingTrigger"));
var _DropdownSelectMarketingList = _interopRequireDefault(require("./DropdownSelectMarketingList"));
var _theme = require("@vds/theme");
var _typography = require("@vds/typography");
var _TitleConfig = _interopRequireDefault(require("../utils/TitleConfig"));
var _utilities = require("@vds-core/utilities");
var _formElements = require("@vds-core/form-elements");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _calculateErrorLabelSpacing() {
  return (0, _javascriptStyleHelpers.calculateRem)(4);
}
var _getIconColor = function _getIconColor(disabled, inverted, colors) {
  if (!inverted && !disabled) {
    return colors.black;
  } else if (disabled) {
    return inverted ? colors.coolGray10 : colors.coolGray3;
  } else {
    return colors.white;
  }
};
var DownCaretIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.6 21.6"
}, /*#__PURE__*/_react["default"].createElement("polygon", {
  points: "10.8 15.71 1.8 6.71 2.62 5.89 10.8 14.07 18.98 5.89 19.8 6.71 10.8 15.71"
}));
var UpCaretIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.6 21.6"
}, /*#__PURE__*/_react["default"].createElement("polygon", {
  points: "18.98 15.71 10.8 7.53 2.62 15.71 1.8 14.89 10.8 5.89 19.8 14.89 18.98 15.71"
}));
var propTypes = {
  /**
   * Items for the Dropdown List. Should use DropdownSelectOption.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * If true disables the dropdown component.
   */
  disabled: _propTypes["default"].bool,
  /**
   * Boolean or a Function that returns a boolean value that determines if component should show the error state/error message. Function receives the 'event' object  on input change.
   */
  error: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
  /**
   * @deprecated errorText
   */
  errorMsg: _propTypes["default"].string,
  /**
   * Message displayed when there is an error
   */
  errorText: _propTypes["default"].string,
  /**
   * @deprecated
   */
  label: _propTypes["default"].string,
  /**
   * Label for reading out meaningful text in aria-labels
   */
  hiddenLabel: _propTypes["default"].string,
  /**
   * Placeholder text to be placed inside the dropdown select component that is displayed before a selection is made.
   */
  placeholder: _propTypes["default"].string,
  /**
   * The width of the dropdown. If no width is passed small dropdowns with be 156px and large dropdowns with be 145px wide.
   */
  width: _propTypes["default"].string,
  /**
   * The size of the entire dropdown.
   */
  size: _propTypes["default"].oneOf(["large", "normal", "medium", "small"]),
  /**
   * The viewport that the dropdown styling should conform to.
   */
  viewport: _propTypes["default"].oneOf(["mobile", "tablet", "desktop"]),
  /**
   * @ignore
   */
  color: _propTypes["default"].object,
  /**
   * Selected item of the Dropdown List.
   */
  selected: _propTypes["default"].string,
  /**
   * @ignore
   * string that sets the typescale for the typography (example: typescale === 'VDS')
   */
  typescale: _propTypes["default"].string,
  /**
   * @ignore
   * config for body typography
   */
  bodyConfig: _propTypes["default"].object,
  /**
   * @ignore
   * config for title typography
   */
  titleConfig: _propTypes["default"].object,
  /**
   * Allows a string to be provided for analytics.
   */
  "data-analyticstrack": _propTypes["default"].string,
  /**
   * Allows a string to be provided for analytics.
   */
  "data-track": _propTypes["default"].string,
  /**
   * Allows a string to be provided for click stream.
   */
  "data-clickstream": _propTypes["default"].string,
  /**
   * Allows a string to be provided for analytics tagging.
   */
  "data-sitecat-level": _propTypes["default"].string,
  /**
   * Allows a string to be provided for analytics tagging.
   */
  "data-sitecat-position": _propTypes["default"].string,
  /**
   * Allows a string to be provided for analytics tagging.
   */
  "data-sitecat-datatrack": _propTypes["default"].string,
  /**
   * Allows a string to be provided for analytics tagging.
   */
  "data-sitecat-cta": _propTypes["default"].string,
  /**
   * Allows a unique ID to be passed to the component.
   */
  id: _propTypes["default"].string,
  /**
   * DropdownSelectMarketing will be displayed in Inverted colors if inverted prop is passed.
   */
  inverted: _propTypes["default"].bool
};
var defaultProps = {
  className: null,
  disabled: false,
  error: undefined,
  size: "normal",
  viewport: "desktop",
  color: _theme.colors,
  selected: undefined,
  typescale: _typography.TypographyConfig.getTypescale(),
  bodyConfig: _typography.BodyConfig,
  titleConfig: _TitleConfig["default"],
  hiddenLabel: null,
  inverted: false
};
var selectWidth = 156;
var selectWidthSmallMobile = 166;
var DropdownWrapper = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  displayName: "DropdownWrapper",
  componentId: "sc-avulwo-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  outline: none;\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n"])), function (_ref) {
  var width = _ref.width;
  return width;
});
var IconWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-avulwo-1"
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: center;\n  outline: none;\n  padding-left: ", ";\n"])), (0, _theme.calculateSpacing)("4X"));
var SelectedTextWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "SelectedTextWrapper",
  componentId: "sc-avulwo-2"
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n"])));
var IconSVGWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "IconSVGWrapper",
  componentId: "sc-avulwo-3"
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  ", ";\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  svg {\n    height: ", ";\n    width: ", ";\n    path,\n    polygon {\n      fill: ", ";\n    }\n  }\n"])), function (_ref2) {
  var iconSize = _ref2.iconSize;
  return (0, _javascriptStyleHelpers.calculateRem)(iconSize);
}, function (_ref3) {
  var iconSize = _ref3.iconSize;
  return (0, _javascriptStyleHelpers.calculateRem)(iconSize);
}, function (_ref4) {
  var iconSize = _ref4.iconSize;
  return (0, _javascriptStyleHelpers.calculateRem)(iconSize);
}, function (_ref5) {
  var iconSize = _ref5.iconSize;
  return (0, _javascriptStyleHelpers.calculateRem)(iconSize);
}, function (_ref6) {
  var tabIndex = _ref6.tabIndex;
  return tabIndex < 0 && "\n    outline: none;\n    pointer-events: none;\n  ";
}, function (_ref7) {
  var iconSize = _ref7.iconSize;
  return (0, _javascriptStyleHelpers.calculateRem)(iconSize);
}, function (_ref8) {
  var iconSize = _ref8.iconSize;
  return (0, _javascriptStyleHelpers.calculateRem)(iconSize);
}, function (_ref9) {
  var iconColor = _ref9.iconColor;
  return iconColor;
});
var Dropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Dropdown, _Component);
  var _super = _createSuper(Dropdown);
  function Dropdown(props) {
    var _this2;
    (0, _classCallCheck2["default"])(this, Dropdown);
    _this2 = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "componentDidUpdate", function (prevProps, prevState) {
      if ((!prevProps.selected || prevProps.selected !== _this2.props.selected) && _this2.props.selected) {
        _this2.setState({
          selectedOption: _this2.props.selected,
          open: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "componentDidMount", function () {
      document.addEventListener("click", _this2.handleClickOutside);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "componentWillUnmount", function () {
      document.removeEventListener("click", _this2.handleClickOutside);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "handleClickOutside", function (e) {
      if (_this2.triggerElem && !_this2.triggerElem.contains(e.target)) {
        _this2.setState({
          open: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "toggle", function (e) {
      _this2.setState({
        open: !_this2.state.open
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "_onKeyDown", function (e) {
      var key = e.keyCode;
      var entered = key === 13 || key === 32;
      var arrowed = key === 38 || key === 40;
      if (entered || arrowed) {
        _this2.setState({
          keyboardFocused: true
        });
      }
      if (arrowed) _this2.toggle();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "setTriggerRef", function (element) {
      _this2.triggerElem = element;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "_getIconSize", function (size, viewport) {
      if ((viewport === "desktop" || viewport === "tablet") && size === "large") {
        return 24;
      } else if (viewport === "mobile" && size === "large") {
        return 20;
      } else if ((viewport === "desktop" || viewport === "tablet") && size === "small") {
        return 16;
      } else return 12;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "_onSelect", function (e) {
      _this2.setState({
        open: false
      });
      _this2.props.onSelect && _this2.props.onSelect(e);
      _this2.triggerElem.focus();
      var _this = (0, _assertThisInitialized2["default"])(_this2);
      (0, _formElements.showError)(e, _this);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "_getWidth", function (size, width, viewport) {
      if (width) return width;
      return size !== "small" ? (0, _javascriptStyleHelpers.calculateRem)(selectWidth) : viewport === "mobile" ? (0, _javascriptStyleHelpers.calculateRem)(selectWidthSmallMobile) : (0, _javascriptStyleHelpers.calculateRem)(selectWidth);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "_getAriaLabel", function () {
      if (_this2.props.hiddenLabel && _this2.state.selectedOption) {
        return _this2.state.selectedOption + "selected from " + _this2.props.hiddenLabel;
      } else if (!_this2.props.hiddenLabel && _this2.state.selectedOption) {
        return _this2.state.selectedOption + "selected from dropdown select";
      } else if (_this2.props.hiddenLabel && !_this2.state.selectedOption) {
        return _this2.props.hiddenLabel;
      } else return "dropdown select";
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "refKey", (0, _setEnvRef["default"])());
    //The trigger should not be focused when an option is clicked
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "_blurTrigger", function () {
      _this2.triggerElem.blur();
    });
    //If the Dropdown is initially entered using keyboard focus, and then entered with mouse click, the keyboard focus has to be set to false
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "_blurList", function () {
      _this2.setState({
        keyboardFocused: false
      });
    });
    _this2.state = {
      open: false,
      selectedOption: _this2.props.selected || undefined,
      keyboardFocused: false,
      error: _this2.props.error === true
    };
    return _this2;
  }
  (0, _createClass2["default"])(Dropdown, [{
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        disabled = _this$props.disabled,
        inverted = _this$props.inverted,
        errorProp = _this$props.error,
        errorMsg = _this$props.errorMsg,
        errorText = _this$props.errorText,
        label = _this$props.label,
        placeholder = _this$props.placeholder,
        size = _this$props.size,
        color = _this$props.color,
        width = _this$props.width,
        viewport = _this$props.viewport,
        selected = _this$props.selected,
        typescale = _this$props.typescale,
        bodyConfig = _this$props.bodyConfig,
        titleConfig = _this$props.titleConfig,
        id = _this$props.id,
        analyticsTrack = _this$props["data-analyticstrack"],
        track = _this$props["data-track"],
        clickStream = _this$props["data-clickstream"],
        cta = _this$props["data-sitecat-cta"],
        dataTrack = _this$props["data-sitecat-datatrack"],
        position = _this$props["data-sitecat-position"],
        level = _this$props["data-sitecat-level"],
        hiddenLabel = _this$props.hiddenLabel;
      var error = this.state.error || typeof errorProp === "boolean" && errorProp;
      var errorMessage = errorMsg ? errorMsg : errorText;
      var selectedOption = this.state.selectedOption || (label ? label : placeholder ? placeholder : "");
      var selectWidth = this._getWidth(size, width, viewport);
      var itemId = (0, _utilities.generateUUID)();
      var selectedOptionId = "selected".concat((0, _utilities.generateUUID)());
      error && !errorMessage && console.error("Error Text for DropdownSelectMarketing MUST be provided");
      var _renderIcons = function _renderIcons() {
        if (_this3.state.open) {
          return UpCaretIcon;
        } else return DownCaretIcon;
      };
      return /*#__PURE__*/_react["default"].createElement(DropdownWrapper, {
        tabIndex: -1,
        id: id,
        className: className,
        width: selectWidth
      }, /*#__PURE__*/_react["default"].createElement(_DropdownSelectMarketingTrigger["default"], {
        bodyConfig: bodyConfig,
        titleConfig: titleConfig,
        typescale: typescale,
        onClick: this.toggle,
        onKeyDown: this._onKeyDown,
        disabled: disabled,
        inverted: inverted,
        error: error,
        size: size,
        viewport: viewport,
        selected: selected,
        setTriggerRef: this.setTriggerRef,
        "data-clickstream": clickStream,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-sitecat-cta": cta,
        "data-sitecat-level": level,
        "data-sitecat-position": position,
        "data-sitecat-datatrack": dataTrack,
        tabIndex: 0,
        "aria-expanded": this.state.open,
        "aria-label": this._getAriaLabel(),
        listId: itemId
      }, /*#__PURE__*/_react["default"].createElement(SelectedTextWrapper, {
        id: selectedOptionId
      }, selectedOption), /*#__PURE__*/_react["default"].createElement(IconWrapper, {
        size: size,
        viewport: viewport
      }, /*#__PURE__*/_react["default"].createElement(IconSVGWrapper, {
        tabIndex: -1,
        iconSize: this._getIconSize(size, viewport),
        disabled: disabled,
        iconColor: _getIconColor(disabled, inverted, color),
        "aria-hidden": true
      }, _renderIcons()))), this.state.open && /*#__PURE__*/_react["default"].createElement(_DropdownSelectMarketingList["default"], {
        width: selectWidth,
        keyboardFocused: this.state.keyboardFocused,
        onSelect: this._onSelect,
        selectedOption: this.props.selectedOption,
        size: size,
        viewport: viewport,
        titleConfig: titleConfig,
        bodyConfig: bodyConfig,
        typescale: typescale,
        color: color,
        error: error,
        inverted: inverted,
        toggleList: this.toggle,
        itemId: itemId,
        trigger: this.triggerElem,
        onClick: this._blurTrigger,
        onBlur: this._blurList,
        "aria-labelledby": selectedOptionId,
        "aria-activedescendant": selectedOptionId,
        tabIndex: -1
      }, children), error && errorMessage && !disabled && !this.state.open && /*#__PURE__*/_react["default"].createElement(_formElements.ErrorText, {
        errorLabelSpacing: _calculateErrorLabelSpacing(size),
        bodyConfig: bodyConfig,
        typescale: typescale,
        errorText: errorMessage,
        error: error,
        color: color,
        surface: inverted ? "dark" : "light"
      }));
    }
  }]);
  return Dropdown;
}(_react.Component);
Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
var _default = exports["default"] = (0, _utilities.withVDSManager)(Dropdown);


//////////////////
// WEBPACK FOOTER
// ./~/@vds/selects/dist/cjs/components/DropdownSelectMarketing.js
// module id = 1567
// module chunks = 0